import React from "react"
import { EditBandFormField, isLikelyUrl } from "./EditBandFormField"
import { Band } from "../../types/bands"

interface WebsiteUrlProps {
  band: Band
}

export const WebsiteUrl: React.FC<WebsiteUrlProps> = ({ band }) => {
  const fieldData = {
    field: "website_url",
    name: "websiteUrl",
    label: "Your website page url",
    placeholder: "The url of your website",
    required: false,
  }

  return (
    <EditBandFormField type="text" fieldData={fieldData} validate={isLikelyUrl} />
  )
}
